var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-466502a7-f933-4db2-bf23-9ed247f7bd7c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16,15.453c-3.594,0-6.518-2.924-6.518-6.519s2.924-6.518,6.518-6.518,6.518,2.924,6.518,6.518-2.924,6.519-6.518,6.519Zm0-10.037c-1.94,0-3.518,1.578-3.518,3.518s1.578,3.519,3.518,3.519,3.518-1.579,3.518-3.519-1.578-3.518-3.518-3.518Z",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.128,29.583h-12.256c-2.078,0-3.768-1.69-3.768-3.769v-4.903c0-2.078,1.69-3.769,3.768-3.769h12.256c2.078,0,3.768,1.69,3.768,3.769v4.903c0,2.078-1.69,3.769-3.768,3.769Zm-12.256-9.44c-.424,0-.768.345-.768.769v4.903c0,.424.345.769.768.769h12.256c.424,0,.768-.345.768-.769v-4.903c0-.424-.345-.769-.768-.769h-12.256Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.7a62a3f22e733633b90bde2269af46c2.svg";
export { ForwardRef as ReactComponent };